import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  fromFirm,
  fromPro,
  fromContext,
  fromNotifications,
} from 'store/selectors'
import { toggleSearchModal, openNotifications } from 'store/actions'

import PageTemplateView from './View'

const PageTemplate = props => (
  <PageTemplateView {...props}>{props.children}</PageTemplateView>
)

PageTemplate.propTypes = {
  children: PropTypes.any,
}

const mapStateToProps = state => ({
  searchModalIsOpen: fromContext.searchModalIsOpen(state),
  firmDetails: fromFirm.getDetails(state, fromPro.getFirmId(state)),
  nickname: fromPro.getNickname(state),
  email: fromPro.getEmail(state),
  locale: fromContext.getLocale(state),
  notifications: fromNotifications.getNotifications(state),
})

const mapDispatchToProps = dispatch => ({
  toggleSearchModal: isExpanded => dispatch(toggleSearchModal(isExpanded)),
  dispatchOpenNotifications: ({ id, toastId }) =>
    dispatch(openNotifications({ id, toastId })),
})

export default connect(mapStateToProps, mapDispatchToProps)(PageTemplate)
